<template>
  <div id="step-2" class="step">
    <p
      class="type type-body-medium dark"
      style="padding: 12px 0; margin-bottom: 10px"
    >
      Klinik Seçin
    </p>
    <ResourceFormSelect v-model="selectedClinic" :options="clinics" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ResourceFormSelect from "@/components/form/items/ResourceFormSelect.vue";
import ApiService from "@/core/services/ApiService";
import { Endpoints } from "@/store/enums/network/Endpoints";
import ResourceFormDatepicker from "@/components/form/items/ResourceFormDatepicker.vue";

export default defineComponent({
  name: "ClinicStep",
  components: { ResourceFormSelect },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const clinics = ref<Array<object>>([]);
    const selectedClinic = ref(null);
    const loading = ref<boolean>(true);

    const fetch = async () => {
      loading.value = true;
      const result = await ApiService.U2MClient.get(
        Endpoints.SETTINGS_CLINIC_INDEX,
        {
          params: {
            items_per_page: 99999,
          },
        }
      );
      clinics.value = result.data.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      loading.value = false;
    };

    onMounted(() => {
      fetch();

      watch(selectedClinic, (val) => {
        emit("update:modelValue", val);
      });
    });

    return {
      loading,
      clinics,
      selectedClinic,
    };
  },
});
</script>

<style lang="scss"></style>
